<div class="message-container">
  <app-avatar [user]="me"></app-avatar>
  <div
    class="textarea-container"
    [class.private]="commentMessage.private"
    [class.open]="messageFocused || commentMessage.text.length"
    (click)="messageFocused = true"
    appClickOutside
    (onClickOutside)="messageFocused = false"
  >
    <div
      class="textarea"
      name="new-thread"
      contenteditable
      [(wysiwyg)]="commentMessage.text"
      [allowMentions]="true"
      [allowHtml]="true"
      #commentField
      (focus)="messageFocused = true"
    ></div>
    @if (!commentMessage.text.length) {
      <div class="placeholder">{{ 'add-a-comment' | translate }}...</div>
    }

    @if (messageFocused || commentMessage.text.length) {
      <div class="message-actions" [@messageActions]>
        @if (enabledAndAllowedFeedbackOptions.includes('annotation')) {
          <button
            appButton
            name="toggle-annotation"
            location="new-comment-thread"
            appTooltip="Draw"
            [iconButton]="true"
            [color]="annotationMode ? 'simple-primary' : 'simple'"
            shape="round"
            height="-1"
            (click)="toggleAnnotationMode.emit()"
          >
            <app-svg src="/assets/icons/annotate-brush.svg"></app-svg>
          </button>
        }

        <button
          appButton
          name="toggle-comment-placement"
          location="new-comment-thread"
          appTooltip="Place comment"
          [iconButton]="true"
          [color]="commentPlacementMode ? 'simple-primary' : 'simple'"
          shape="round"
          height="-1"
          (click)="placeComment.emit(!commentPlacementMode)"
        >
          <app-svg src="/assets/icons/target.svg"></app-svg>
        </button>

        @if (asset.type === 'video') {
          <button
            appButton
            name="toggle-video-frame-position"
            location="new-comment-thread"
            [appTooltip]="commentMessage.addVideoFramePosition ? 'Remove timestamp' : 'Add timestamp'"
            [iconButton]="true"
            [color]="commentMessage.addVideoFramePosition ? 'simple-primary' : 'simple'"
            shape="round"
            height="-1"
            (click)="commentMessage.addVideoFramePosition = !commentMessage.addVideoFramePosition"
          >
            <app-svg src="/assets/icons/clock-outline.svg"></app-svg>
          </button>
        }

        <div class="separator"></div>

        @if (galleryPermissions.can_edit && isTeamMember) {
          <button
            appButton
            name="toggle-private"
            location="new-comment-thread"
            appTooltip="Team only"
            [iconButton]="true"
            [color]="commentMessage.private ? 'simple-orange' : 'simple'"
            shape="round"
            height="-1"
            (click)="togglePrivate()"
          >
            @if (commentMessage.private) {
              <app-svg src="/assets/icons/lock.svg"></app-svg>
            } @else {
              <app-svg src="/assets/icons/lock-off.svg"></app-svg>
            }
          </button>
        }

        <app-context-menu
          [options]="{ width: '360px', noSpacing: true }"
          class="emoji-toggle"
          verticalPosition="top"
          #emojiMenu
        >
          <button
            appButton
            name="add-emoji"
            location="new-comment-thread"
            [iconButton]="true"
            color="simple"
            height="-1"
            appTooltip="Add emojis"
            contextButton
            shape="round"
          >
            <app-svg src="/assets/icons/24/smiley-outline.svg"></app-svg>
          </button>
          <div contextContent>
            @defer (when emojiMenu.isOpen()) {
              <app-emoji-selector (onSelect)="addEmoji($event)"></app-emoji-selector>
            } @error {}
          </div>
        </app-context-menu>
      </div>
    }
  </div>
</div>

<div class="message-footer">
  @if (commentMessage.private) {
    @let teamWatchers = teamWatchers$ | async;

    <div class="watchers-container private">
      <div class="lock-container">
        <app-svg src="/assets/icons/lock.svg"></app-svg>
      </div>
      <div>
        <b>
          @if (teamWatchers.length > 0) {
            @if (teamWatchers.length === 1) {
              1 Team Member
            } @else {
              {{ teamWatchers.length }} Team Members
            }
          } @else {
            No one
          }
        </b>
        will be notified
      </div>
    </div>
  } @else {
    @if (watchers$ | async; as watchers) {
      <app-asset-watchers-context-menu
        [gallery]="gallery"
        [asset]="asset"
        [galleryPermissions]="galleryPermissions"
        [isTeamMember]="isTeamMember"
      >
        <div class="watchers-container" [class.clickable]="galleryPermissions.can_edit && isTeamMember">
          <div class="watchers">
            @for (watcher of watchers | slice: 0 : 5; track watcher.id) {
              <app-avatar class="avatar" [user]="watcher"></app-avatar>
            }
          </div>
          <div>
            <b>
              @if (watchers.length > 0) {
                @if (watchers.length === 1) {
                  {{ watchers[0].first_name }}
                } @else {
                  {{ watchers.length }} People
                }
              } @else {
                No one
              }
            </b>
            will be notified
          </div>
        </div>
      </app-asset-watchers-context-menu>
    }
  }
  <div class="spacer"></div>
  <button
    [class.disabled]="!commentMessage.text"
    appButton
    name="send"
    location="new-comment-thread"
    color="primary"
    data-test-id="comment"
    shape="round"
    height="1"
    spacing="3"
    (click)="postNewThread()"
  >
    Send
  </button>
</div>
